import axios from 'axios';
import Amplify, { Auth, API, Logger } from 'aws-amplify';

import AWS from 'aws-sdk';

import awsConfig from '@/aws-exports.js';

import {getEnvVar} from '@/library/utils/env-vars';

import { ClearStorage } from '@/vessi.utils';

const IdentityPoolId = getEnvVar('IdentityPoolId')
	, _PROVIDER = getEnvVar('_PROVIDER');

const userLogger = new Logger('UserLogger', 'DEBUG');

import * as suscripcionUtils from '@/library/suscripcion';

import * as asyncConfig from '@/async-config';

export default {
	async signIn({commit, dispatch, state, rootState}, payload={}){

		state.isloading = true;

		ClearStorage();

		let username = payload.username;
		let clave = payload.pass;
		let {versionCheckeada = false} = payload

		let token = null;
		let identityId = null;
		let sii_token = null;

		try{
			if(!versionCheckeada)
				await dispatch('version/checkVersion', null, { root: true })
		}catch(err){
			state.isloading = false;
			return false;
		}

		try{

			let resp = await siiLogin(username, clave);
			
			if(resp.estado == 3){
				throw resp.glosa;
			}
			
			identityId = resp.openId.IdentityId;
			token = resp.openId.Token;

			sii_token = resp.sii_token;
		}catch(err){
			
			let error = err.response;

			if( error != null ){
				let {data={}}=error;
				if( data.estado != null && data.estado != 0 ){
					error = data.glosa;
				}
			}else{
				error = 'Ha ocurrido un error, vuelva a intentarlo más tarde.'
			}
			
			commit('auth_error', error)
			return error
		}

		let token_backend = !token? false: token || false;

		if(!!token_backend){

			try{

				

				AWS.config.update({
					region: getEnvVar('awsRegion')
				});

				let credentials = new AWS.CognitoIdentityCredentials({
				   IdentityPoolId: IdentityPoolId,
				   IdentityId: identityId,
				   LoginId: username,
				   Logins: {
				      'cognito-identity.amazonaws.com': token_backend
				   }
				});

				AWS.config.credentials = credentials;
				// userLogger.debug('Credenciales creadas',token_backend, identityId, username);

				let getCredentials = ()=>{
					return new Promise((resolve, reject) => {
						AWS.config.credentials.get(function(err){

							if(err)	reject(err);
							else{
								// Credentials will be available when this function is called.
								var accessKeyId = AWS.config.credentials.accessKeyId;
								var secretAccessKey = AWS.config.credentials.secretAccessKey;
								var sessionToken = AWS.config.credentials.sessionToken;
								let username = AWS.config.credentials.params.LoginId;
								let expireTime = AWS.config.credentials.expireTime;
								resolve({username, expireTime,accessKeyId,secretAccessKey,sessionToken});
							}
						});
					})
				}

				let cr = await getCredentials();

				// let expireTime = new Date(cr.expireTime).getTime();
				let expireTime = new Date().getTime() + (6*60*60*1000);
				// console.log( (expireTime - new Date().getTime())/1000, new Date(expireTime) )
				
				// userLogger.debug('developerSignIn', username,identityId, token_backend, expireTime);

				//console.log('expireTime', new Date(expireTime))

				// await dispatch('developerSignIn', {username,identityId, token:token_backend, expireTime});

				commit('auth_success', username, token_backend, identityId);
				let signinResp = await Auth.federatedSignIn(
					'developer',
					{
						token:token,
						identity_id: identityId, // Optional
						expires_at: expireTime // the expiration timestamp
					},
					{
						username,
						identityId,
						expires_at: expireTime,
						token: token_backend
					}
				);


				commit('auth_success', username, sii_token, identityId);
				

				try {
					await asyncConfig.actualizar();
				}
				catch(err) {
					console.log('Error al obtener configuración de aplicación');
				}
				
				// Suscribirse a notificaciones
				await suscripcionUtils.suscribir();
				
				return await Auth.currentAuthenticatedUser();
			}catch(err){
				commit('auth_error', err);
				// userLogger.debug('auth_error',err);

				return err;
			}
		}

		return false;
	},
	async signOut({commit, dispatch, rootState}, callback=null){

		let resp = null;

		ClearStorage();

		try{
			resp = await Auth.signOut();
			
			// Desuscribirse de notificaciones
			suscripcionUtils.desuscribir();
		}catch(err){
			resp = err;
		}

		rootState.empresas.selected = undefined;

		await dispatch('version/resetEstados', {}, { root: true });

		if(!!callback)	callback(resp);

		return resp;
	},
	async getSession(){

		let resp = null;
		try{
			resp = await Auth.currentAuthenticatedUser()
		}catch(err){
			resp = err;
		}
		return resp;
	},
	// retornar Promise
	getCurrentUser(){

		return Auth.currentAuthenticatedUser();
	},
	// retornar Promise
	refreshToken({commit, dispatch, state, rootState}, callback){
		dispatch('getCurrentUser').then(credentials=>{

			let username = credentials.username;
			let identityId = credentials.identityId;
			
			dispatch('getRefreshedToken', username,identityId).then(response=>{
				return new Promise((res, rej) => {
					const data = {
						token: response.token, // the token from the provider
						expires_at: response.expires_at, // the timestamp for the expiration
						identity_id: response.identity_id, // optional, the identityId for the credentials
					}

					let token = response.token;
					let newIdentityId = response.identity_id;

					dispatch('generateCredentials', token, newIdentityId);

					console.log( 'promise', new Date( response.expires_at ) )
					res(data);
				})
			}).catch(err=>{
				console.log('handler err', err)
				throw err;
			})

		}).catch(err=>{
			console.log('creds err', err)
			throw err;
		})
	},
	// retornar promise
	getRefreshedToken({state}, {user, identityId}){

		let params = {
			body:{
				user: user,
				identityId: identityId,
			}
		};

		return API.post('apiAuthSII', '/refresh-token', params);
	},
	// retornar promise
	getAWSCredentials({dispatch}){
		
		return new Promise((resolve, reject) => {
			try{
				Auth.currentCredentials().then(user=>{

					// userLogger.debug('Credenciales', user.accessKeyId);
					resolve(user);
				})
				.catch(err=>{
					// userLogger.debug('Credenciales - Error', err)
					throw err;
				})
		}catch(err){
			AWS.config.update({
				region: 'us-east-1'
			});
			AWS.config.credentials.get(function(err){

				if(err)	reject(err);
				else{
					// Credentials will be available when this function is called.
					var accessKeyId = AWS.config.credentials.accessKeyId;
					var secretAccessKey = AWS.config.credentials.secretAccessKey;
					var sessionToken = AWS.config.credentials.sessionToken;
					let username = AWS.config.credentials.params.LoginId;
					let expireTime = AWS.config.credentials.expireTime;
					
				}
			});
			// userLogger.debug('err', err);
			reject(err)
		}
		})
	},
	developerSignIn({commit, dispatch, state}, {username,identityId, token, expireTime}){

		commit('auth_success', username, state.siiToken, identityId);

		let expiresAt = new Date(expireTime).getTime();

		// userLogger.debug('developerSignIn -> ', username,identityId, token, expiresAt)

		return Auth.federatedSignIn(
			'developer',
			{
				token:token,
				identity_id: identityId, // Optional
				expires_at: expiresAt // the expiration timestamp
			},
			{
				username,
				identityId,
				expires_at: expiresAt,
				token
			}
		);
	},
	onSessionExpired({commit, state}, err){

		console.log('onSessionExpired',err);

		commit('auth_expired', err);
		window.location.replace('/');
	},
	async eventoActualizarContribuyente({dispatch, rootGetters}, payload){
		let currentUser = await Auth.currentAuthenticatedUser({
			bypassCache: false  // Optional, By default is false. If set to true, this call will send a request to Cognito to get the latest user data
		});

		let user = currentUser.username;

		let contribuyente = rootGetters['empresas/selectedRut'];

		let init = {
			body:{
				usuario:user
			}
		};

		let path = `/evento/actualizar/contribuyente/${contribuyente}`;
			let api = 'eBoletaActualizador';
		
		let resp = await API.post(api, path, init);

		dispatch('getCantidadActualizacionesDiarias');
	},
	async getCantidadActualizacionesDiarias({commit, rootGetters}, payload){
		let currentUser = await Auth.currentAuthenticatedUser({
			bypassCache: false  // Optional, By default is false. If set to true, this call will send a request to Cognito to get the latest user data
		});

		let user = currentUser.username;

		let contribuyente = rootGetters['empresas/selectedRut'];

		let path = `/evento/actualizar/contribuyente/${contribuyente}`;
		let api = 'eBoletaActualizador';

		let init = {
			queryStringParameters:{
				usuario:user
			}
		}
		
		let resp = await API.get(api, path, init);

		commit('ACT_CANTIDAD', resp);
	}
}
// retornar promise
async function siiLogin(username, clave){

	let params = {
		body:{
			rut: username.split('-')[0],
			dv: username.split('-')[1],
			clave
		}
	};

	let apiname = 'apiAuthSII';
	let apipath = '/sign-in';

	try{
		// se valida el usuario y contraseña para
		// SII y de obtiene el identity id para el usuario
		let resp = await API.post(apiname, apipath, params);
		return resp;
	}catch(err){
		
		throw err;
	}
}